import moment from 'moment'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { trackEcommerce, trackGA4Ecommerce } from '../../gtm'
import { roundPrice } from '../../utils'
import LaInclusionsForm from '../checkout/LaInclusionsForm'
import { convertCurrency } from '../helpers'
import useCurrentShop from './hooks/useCurrentShop'
import useLaInclusions from './hooks/useLaInclusions'
import useStep from './hooks/useStep'

export default function Step3() {
  const { shopInfo } = useCurrentShop()
  const { inclusionsData, saveInclusions } = useLaInclusions()
  const { guestsSplitting, selectedTrip } = useSelector(
    ({ guestsSplitting, selectedTrip }) => ({
      guestsSplitting,
      selectedTrip,
    }),
  )

  useEffect(() => {
    const products = []
    const ga4Products = []
    let value = 0
    guestsSplitting.forEach((cabin) => {
      cabin.pricing.forEach((pricing) => {
        const price = Number(
          roundPrice(
            convertCurrency(pricing.priceNet, shopInfo.currency, 'USD'),
          ),
        )
        value += price
        const ga4Item = {
          item_id: pricing.id,
          price,
          item_variant: `${selectedTrip.itinerary.title} / ${moment(
            pricing.dateFrom,
          )
            .utc()
            .locale('en')
            .format('DD MMM')}-${moment(pricing.dateTo)
            .utc()
            .locale('en')
            .format('DD MMM')} / ${
            pricing.isDiver
              ? `${pricing.qty} diver(s)`
              : `${pricing.qty} non-diver(s)`
          }`,
          item_brand: 'PADI',
          item_name: shopInfo.title,
          item_category: 'PADI Travel',
          item_category2: 'Liveaboard',
          item_category3: cabin.title,
          item_list_name: 'PADI Travel Liveaboards - Select Cabin',
          quantity: pricing.qty,
        }
        const item = {
          id: pricing.id,
          price: roundPrice(
            convertCurrency(pricing.priceNet, shopInfo.currency, 'USD'),
          ),
          variant: `${selectedTrip.itinerary.title} / ${cabin.title} / ${moment(
            pricing.dateFrom,
          )
            .utc()
            .locale('en')
            .format('DD MMM')}-${moment(pricing.dateTo)
            .utc()
            .locale('en')
            .format('DD MMM')} / ${
            pricing.isDiver
              ? `${pricing.qty} diver(s)`
              : `${pricing.qty} non-diver(s)`
          }`,
          brand: `${shopInfo.title}|${window.affiliateId}`,
          name: shopInfo.title,
          category: 'Liveaboard',
          quantity: pricing.qty,
        }
        ga4Products.push(ga4Item)
        products.push(item)
      })
    })
    trackGA4Ecommerce(
      'view_cart',
      {
        currency: 'USD',
        value,
        items: ga4Products,
      },
      'PADI Travel - Liveaboards',
    )
    trackEcommerce(
      'checkout_step_extra',
      {
        checkout: {
          actionField: {
            step: 2,
          },
          products,
        },
      },
      'USD',
    )
  }, [guestsSplitting, shopInfo, selectedTrip])
  const { setStep } = useStep()
  const onSubmit = (incl) => {
    saveInclusions(incl)
    setStep(4)
  }
  return (
    <div className='step3'>
      <div className='main-content'>
        <h2 className='step-title'>
          <span className='number'>3</span>
          <FormattedMessage defaultMessage='Add some extras' />
        </h2>
        <LaInclusionsForm
          initialValues={inclusionsData}
          saveSelectedInclusions={onSubmit}
          showHint
        />
      </div>
    </div>
  )
}
